require('select2');
require('select2/dist/css/select2.min.css');

function initUserSerial() {

	if( $('#serialuser_form').length ){

		$('.select-deco').select2();

		$('.btn-repair').on('click', function(e){

			e.preventDefault();

			$('#id_serial').val( $(this).data('id') );
			$('#model').val( $(this).data('model') );
			$('#serial_number').val( $(this).data('serial') );
			$('#bought_date').val( $(this).data('date') );

			$('#serialuser_form').slideDown();

		});

		$('#close_serialuser_form').on('click', function(e){
			e.preventDefault();
			$('#serialuser_form').slideUp();
		});

	}	
}

module.exports = initUserSerial;


// WEBPACK FOOTER //
// ./js/serial-user.js